import api from "../../../../../api";
import React from "react";
import utils from "../../../../../utils";
import values from "../../../../../values";
import Context from "../../../../../context";
import SuperAgentScreen from "..";

import { TModal } from "../../../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../../../components";
import { IFindUserInformation } from "../../../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../../../types/superAgent.interface";

const SuperAgentContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedSuperAgent, setSelectedSuperAgent] = React.useState<any>();
  const [requestSuperAgent, setRequestSuperAgent] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
      },
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  const resultSuperAgent = useQuery(
    [
      values.useQueryKeys.getAllSuperAgent,
      requestSuperAgent?.page,
      requestSuperAgent?.search?.value,
      requestSuperAgent?.filters,
    ],
    () =>
      api.post.administrator.getAllSuperAgent({
        filters: requestSuperAgent?.filters,
        search: requestSuperAgent?.search,
        limit: requestSuperAgent?.limit,
        page: requestSuperAgent?.page,
      })
  );

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateSuperAgent) {
    setIsLoading(true);
    const result = await api.post.administrator.createSuperAgent(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultSuperAgent.refetch();
      setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateSuperAgent) {
    setIsLoading(true);
    const result = await api.put.administrator.updateSuperAgent(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultSuperAgent.refetch();
      setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.administrator.deleteSuperAgent(userId);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultSuperAgent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.SuperAgentCityScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        updateFunction,
        createFunction,
        requestSuperAgent,
        selectedSuperAgent,
        setRequestSuperAgent,
        setSelectedSuperAgent,
      }}
    >
      <SuperAgentScreen rqSuperAgent={resultSuperAgent} />
      <DeleteModal
        open={showModal === "DELETE"}
        user={selectedSuperAgent}
        data={selectedSuperAgent}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      />
    </Context.SuperAgentCityScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default SuperAgentContainer;
